export const ERROR_MSG_SECTION_ONE = "We're sorry, but we cannot find enough data on your profile, in order to complete the identity verification procedure."

export const ERROR_MSG_SECTION_TWO = "Please contact customer service with any further questions that you may have at "

export const ERROR_MSG_SECTION_THREE = "https://esignatureguarantee.com/contact"